import React from 'react';
import raven from 'raven-js';
import { render } from 'react-dom';
import Loadable from 'react-loadable';
import { Provider } from 'react-redux';

import auth from './library/auth.js';
import configureStore from './stores/configureStore.js';

import Loading from './components/loading';
import Notifications from './components/notification';

raven.config( process.env.SENTRY_DSN ).install();

// Initialize firebase before React rendering
auth.loggedIn();

const store = configureStore();

const loaders = [{
    path: 'login',
    divID: 'react-activism-login',
    loader: () => import('./components/login/index.js')
}, {
    path: 'wordpress',
    divID: 'react-activism-wordpress-menus',
    loader: () => import('./modules/wordpress-menus-widget/index.js')
}, {
    path: 'commit',
    divID: 'react-activism-commit',
    loader: () => import('./modules/commit-to-vote/index.js')
}, {
    path: 'field-admin',
    divID: 'react-activism-users',
    loader: () => import('./modules/field-admin/index.js')
}, {
    path: 'register',
    divID: 'react-activism-voter-reg',
    loader: () => import('./modules/voter-reg/index.js')
}, {
    path: 'events-partners',
    divID: 'react-activism-events-partners',
    loader: () => import('./modules/events-partners/index.js')
}, {
    path: 'events-queryable',
    divID: 'react-activism-events-queryable',
    loader: () => import('./modules/events-queryable/index.js')
}, {
    path: 'events',
    divID: 'react-activism-events',
    loader: () => import('./modules/events/index.js')
}, {
    path: 'dialer',
    divID: 'react-activism-dialer',
    loader: () => import('./modules/dialer/gate.js')
}, {
    path: 'activist',
    divID: 'react-activism-dashboard',
    loader: () => import('./modules/activist/index.js')
}, {
    path: 'polling-place',
    divID: 'react-activism-polling',
    loader: () => import('./modules/polling-place/index.js')
}, {
    path: 'volunteer',
    divID: 'react-activism-volunteer',
    loader: () => import('./modules/volunteer/index.js')
}, {
    path: 'p2a',
    divID: 'react-activism-p2a',
    loader: () => import('./modules/phone2action/index.js')
}, {
    path: 'store',
    divID: 'react-activist-store',
    loader: () => import('./modules/store/index.js')
}, {
    path: 'account',
    divID: 'react-activist-account',
    loader: () => import('./modules/wordpress-login/index.js')
}, {
    path: 'donate',
    divID: 'react-activist-donate',
    loader: () => import('./modules/donate/index.js')
}, {
    path: 'amplify',
    divID: 'react-activist-amplify',
    loader: () => import('./modules/amplify/index.js')
}, {
    path: 'turf-selector',
    divID: 'react-turf-selector',
    loader: () => import('./modules/turf-code-selector/index.js')
}, {
    path: 'event-finder-map',
    divID: 'react-event-finder-map',
    loader: () => import('./modules/event-finder-map/index.js')
}];

if ( process.env.NODE_ENV !== 'production' && process.env.REACT_APP_WORDPRESS_MOUNT !== 'true' ) {
    const path = window.location.pathname.split('/')[1];

    for ( const i in loaders ) {
        const loader = loaders[i];

        if ( path !== '' && loader.path.startsWith( path ) ) {
            const LoadableComponent = Loadable({
                // eslint-disable-next-line
                loader: loader.loader,
                loading: Loading
            });

            render(
                <Provider store={ store }>
                    <div>
                        <LoadableComponent />
                        <Notifications />
                    </div>
                </Provider>,
                document.getElementById('root')
            );
        }
    }

} else {
    for ( const i in loaders ) {
        const loader = loaders[i];

        if ( document.getElementById( loader.divID ) ) {
            const LoadableComponent = Loadable({
                // eslint-disable-next-line
                loader: loader.loader,
                loading: Loading
            });

            render(
                <Provider store={ store }>
                    <div>
                        <LoadableComponent />
                        <Notifications />
                    </div>
                </Provider>,
                document.getElementById( loader.divID )
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/index.js